import { FC } from 'react';
import BranchInfo from './BranchInfo';
import UseBranchInfo from './UseBranchInfo';

const BranchInfoContainer: FC = () => {
  return <BranchInfo {...UseBranchInfo()} />;
};

export default BranchInfoContainer;
